// extracted by mini-css-extract-plugin
module.exports = {"url":"NewReturnForm_url__1ABvB","pseudoInputContainer":"NewReturnForm_pseudoInputContainer__1u56I","form":"NewReturnForm_form__37niL"};